import React from "react"
import { Icon, Popup, Progress } from "semantic-ui-react"
import shop from "shop/shop"
import ProductPrice                                                                   from "components/Product/ProductPrice"
import MediaQuery from "react-responsive"

const MinOrderValue = ( { sum } ) => {
  if ( !shop.config.MIN_ORDER_VALUE ) return null
  const prc = (sum / shop.config.MIN_ORDER_VALUE) * 100
  const aboveMin = sum > shop.config.MIN_ORDER_VALUE
  if ( aboveMin || sum === 0 ) return null
  // return <div>{prc}</div>
  return <div className="pt0">
    <MediaQuery minWidth={768}>
      <div>
        <div className="ml0">
          <Progress size="tiny"  active={false} percent={prc}/>
        </div>
      </div>
    </MediaQuery>
  </div>
}

export default MinOrderValue


// WEBPACK FOOTER //
// ./src/theme/lindtbShop/components/Cart/MinOrderValue.js